export default "__VITE_ASSET__CiadvQfN__"